import Action from './action';

const initialState = {
    IDPhotoOneFileId: '',
    IDPhotoOnePreivewUrl: '',
    errorTextOne: '',
    IDPhotoTwoFileId: '',
    IDPhotoTwoPreivewUrl: '',
    errorTextTwo: '',
    IDPhotoTotalErrorText: ''
};

export default (state = initialState, action: {type: string, playload: string}) => {
    switch (action.type) {
        case Action.UPDATE_IDPHOTO_ONE: {
            return {
                ...state,
                IDPhotoOneFileId: action.playload
            }
        }
        case Action.UPDATE_IDPHOTO_ONE_PREVIEW_URL: {
            return {
                ...state,
                IDPhotoOnePreivewUrl: action.playload
            }
        }
        case Action.UPDATE_IDPHOTO_TWO: {
            return {
                ...state,
                IDPhotoTwoFileId: action.playload
            }
        }
        case Action.UPDATE_IDPHOTO_TWO_PREVIEW_URL: {
            return {
                ...state,
                IDPhotoTwoPreivewUrl: action.playload
            }
        }
        case Action.UPDATE_ERROR_TEXT_ONE: {
            try {
                action.playload && (window as any).mailStats.show('ID_photo_input_error_1', { errorText: action.playload })
            } catch(e) {}
            return {
                ...state,
                errorTextOne: action.playload
            }
        }
        case Action.UPDATE_ERROR_TEXT_TWO: {
            try {
                action.playload && (window as any).mailStats.show('ID_photo_input_error_2', { errorText: action.playload })
            } catch(e) {}
            return {
                ...state,
                errorTextTwo: action.playload
            }
        }
        case Action.UPDATE_IDPHOTO_TOTAL_ERROR_TEXT: {
            return {
                ...state,
                IDPhotoTotalErrorText: action.playload
            }
        }
        default: return state;
    }
}
